import { useRef } from 'react'
import SectionLabel from './SectionLabel'
import { WA_NUMBER, WA_MESSAGES } from '../constants'

export default function WhySection() {
  const rowRef = useRef(null)
  const scroll = dir => rowRef.current?.scrollBy({ left: dir * 340, behavior: 'smooth' })

  const points = [
    {
      title: 'Direct Guidance',
      text: 'Book directly with your guide. No middlemen, no agency fees, and total flexibility.',
      icon: '🏆',
      gradient: 'linear-gradient(135deg, var(--green-dark), var(--green))',
    },
    {
      title: 'Small Groups',
      text: 'We cap our groups at 6 people. More safety, more interaction, and a better experience.',
      icon: '👥',
      gradient: 'linear-gradient(135deg, var(--green), var(--green-mid))',
    },
    {
      title: 'Zero Hidden Costs',
      text: 'Total transparency. All permits, flights, and meals are included from the start.',
      icon: '💰',
      gradient: 'linear-gradient(135deg, var(--ink), var(--green-dark))',
    },
    {
      title: 'Manaslu Expert',
      text: 'We have crossed Larkya La more than 40 times in every weather condition imaginable.',
      icon: '⛰️',
      gradient: 'linear-gradient(135deg, var(--green-mid), var(--green-dark))',
    },
  ]

  return (
    <section className="section bg-stone">
      <SectionLabel>Why Choose Us?</SectionLabel>
      <h2 className="section-title">Solitude over crowds.</h2>

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '20px' }}>
        <button className="scroll-arrow" onClick={() => scroll(-1)} aria-label="Previous">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div ref={rowRef} className="scroll-row" style={{ flex: 1 }}>
          {points.map(p => (
            <div
              key={p.title}
              className="scroll-row-item"
              style={{
                width: '320px', height: '360px', borderRadius: 'var(--radius-lg)',
                background: p.gradient, position: 'relative', overflow: 'hidden',
                display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',
                padding: '28px', color: 'white',
              }}
            >
              <div style={{ fontSize: '32px', marginBottom: '16px' }}>{p.icon}</div>
              <h3 style={{ fontFamily: 'var(--serif)', fontSize: '22px', fontWeight: 600, marginBottom: '10px' }}>
                {p.title}
              </h3>
              <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.8)', lineHeight: 1.6, marginBottom: '20px' }}>
                {p.text}
              </p>
              <a
                href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGES.general)}`}
                target="_blank" rel="noreferrer"
                className="btn btn-outline btn-sm"
                style={{ alignSelf: 'flex-start' }}
              >
                Ask me
              </a>
            </div>
          ))}
        </div>
        <button className="scroll-arrow" onClick={() => scroll(1)} aria-label="Next">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      </div>
    </section>
  )
}
